import { CheckCircle2, CircleAlert, History, Languages, ShieldCheck } from "lucide-react";
import type { ReactNode } from "react";
import { StatusHint } from "../ui/status-hint";
import styles from "./decision-ribbon.module.css";

export function DecisionRibbon({
  status,
  locale,
  version,
  completedChecks,
  totalChecks,
  checksLabel = "İçerik kalitesi",
  checksDescription,
  dirty,
  nextActionLabel = "Yayın araçları",
  onNextAction,
}: {
  status: ReactNode;
  locale: string;
  version: number;
  completedChecks: number;
  totalChecks: number;
  checksLabel?: string;
  checksDescription?: string;
  dirty: boolean;
  nextActionLabel?: string;
  onNextAction: () => void;
}) {
  const complete = totalChecks > 0 && completedChecks === totalChecks;

  return (
    <section className={styles.ribbon} aria-label="İçerik karar özeti">
      <div className={styles.item}>
        <ShieldCheck size={16} aria-hidden="true" />
        <span>Durum</span>
        <strong>{status}</strong>
      </div>
      <div className={styles.item}>
        <Languages size={16} aria-hidden="true" />
        <span>Dil</span>
        <strong>{locale}</strong>
      </div>
      <div className={styles.item}>
        <StatusHint
          className={styles.checkIcon}
          icon={complete ? <CheckCircle2 size={16} /> : <CircleAlert size={16} />}
          label={checksDescription || (complete ? "Tüm kontroller tamamlandı" : `${totalChecks - completedChecks} kontrol tamamlanmadı`)}
          placement="bottom"
          tone={complete ? "success" : "warning"}
        />
        <span>{checksLabel}</span>
        <strong aria-label={`${completedChecks}/${totalChecks} kontrol tamamlandı`}>{completedChecks}/{totalChecks}</strong>
      </div>
      <div className={`${styles.item} ${styles.mono}`}>
        <History size={16} aria-hidden="true" />
        <span>Sürüm</span>
        <strong>{version}</strong>
      </div>
      <div className={styles.state} data-dirty={dirty}>
        <span aria-hidden="true" />
        {dirty ? "Kaydedilmemiş değişiklik" : "Güncel"}
      </div>
      <button className={styles.action} type="button" onClick={onNextAction}>
        {nextActionLabel}
      </button>
    </section>
  );
}
